import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { partDetailsToolConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const PartDetailsToolStack = createStackNavigator();

const PartDetailsToolNavigator = () => {
  return (
    <PartDetailsToolStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {partDetailsToolConfig.map(({ Component, name }) => (
        <PartDetailsToolStack.Screen key={name} name={name} component={Component} />
      ))}
    </PartDetailsToolStack.Navigator>
  );
};

export { PartDetailsToolNavigator };
